import { FIREBASE as CONFIG } from 'config';
import { Firebase } from './types';

class FirebaseApp {
  public firebase!: Firebase;

  public async init() {
    const firebase = await this.load();
    this.firebase = firebase;
    return this.initApp();
  }
  private async load() {
    const module = await import(/* webpackChunkName: "firebase-app" */ 'firebase/app');
    return module.default;
  }

  private initApp() {
    return this.firebase.initializeApp(CONFIG);
  }
  public async reinitialize() {
    await this.firebase.app().delete();
    return this.initApp();
  }
}

export default FirebaseApp;
